import {
  Dimensions,
  FlatList,
  Image,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  Modal,
  TouchableWithoutFeedback,
  Pressable,
} from "react-native";
import React, { useState } from "react";
import {
  BatteryStatus,
  ModalDel,
  ParkstationAll,
  SuggestedParkingStation,
} from "../../../Constants/Data";
import AppColors from "../../../Constants/AppColors";
import AppFonts from "../../../Constants/AppFonts";
import AppImages from "../../../Constants/AppImages";
import Appstyles from "../../../Constants/AppStyles";
const { width, height } = Dimensions.get("window");
const SugestedParkStation = () => {
  const [selectedItem, setSelectedItem] = React.useState(1);

  const [DotModal, setDotModal] = React.useState(false);
  const [Modalvisible1, setModalvisible1] = React.useState(false);

  const [selectedButton, setSelectedButton] = React.useState(1);

  const handleBoxPressbtn = (item) => {
    setSelectedButton(item);
  };
  //----------search-----
  const SuggestedParkingStations = [
    {
      id: 1,

      Vishrantwadiune: "Vishrantwadi, Kalas Road, Pune, Maharashtra...",
    },
    {
      id: 2,

      Vishrantwadiune: "Vishrantwadi, Kalas Road, Pune, Maharashtra...",
    },
    {
      id: 3,

      Vishrantwadiune: "Vishrantwadi, Kalas Road, Pune, Maharashtra...",
    },
    {
      id: 4,

      Vishrantwadiune: "Vishrantwadi, Kalas Road, Pune, Maharashtra...",
    },
    {
      id: 5,

      Vishrantwadiune: "Vishrantwadi, Kalas Road, Pune, Maharashtra...",
    },
    {
      id: 6,

      Vishrantwadiune: "Vishrantwadi, Kalas Road, Pune, Maharashtra...",
    },
    {
      id: 7,

      Vishrantwadiune: "Vishrantwadi, Kalas Road, Pune, Maharashtra...",
    },
  ];
  const [data, setData] = useState(SuggestedParkingStations);
  const [searchText, setSearchText] = useState(""); // State for search input

  const handleSearch = (text) => {
    setSearchText(text);
    // Implement search logic here to filter the data based on the entered text
    const filteredData = SuggestedParkingStations.filter((item) =>
      item.Vishrantwadiune.toLowerCase().includes(text.toLowerCase())
    );
    setData(filteredData);
  };
  //-------Del FlatList ---------//
  const handleThreeDotPress = (item) => {
    setSelectedItem(item);
    setDotModal(true);
  };
  const handleDeleteConfirmation = () => {
    setDotModal(false);
    setModalvisible1(true);
  };
  const handleDelete = () => {
    const updatedData = data.filter((item) => item.id !== selectedItem.id);
    setData(updatedData);
    setModalvisible1(false);
    setSelectedItem(null);
  };

  return (
    <View style={Appstyles.backgrnd7}>
      <View style={Appstyles.viewofview7}>
        <View style={Appstyles.Searchvi6}>
          <TextInput
            style={Appstyles.TextInputr7}
            placeholder="Search Station Name, code, Address..."
            placeholderTextColor={"#AAAAAA"}
            editable={true}
            value={searchText} // Bind search input value to state
            onChangeText={handleSearch}
          />

          <View style={Appstyles.SearchImageView}>
            <Image source={AppImages.search} style={Appstyles.SearchImage} />
          </View>
        </View>

        <Image
          source={AppImages.Import}
          style={Appstyles.ImpoShare7}
          resizeMode="contain"
        />

        <Image
          source={AppImages.Shareit}
          style={Appstyles.ImpoShare7}
          resizeMode="contain"
        />
      </View>
      <View style={{}}>
        <FlatList
          showsVerticalScrollIndicator={false}
          data={data}
          ListFooterComponent={() => <View style={{ padding: 90 }} />}
          renderItem={({ item }) => (
            <TouchableOpacity
              style={{
                backgroundColor:
                  selectedItem === item ? AppColors.sandal : AppColors.white,
                marginHorizontal: 20,
                borderRadius: selectedItem === item ? 10 : 5,
                borderWidth: selectedItem === item ? 0.5 : 0.5,
                marginBottom: 20,
                paddingVertical: 5,

                borderColor:
                  selectedItem === item ? AppColors.sandal : AppColors.brown,
              }}
              onPress={() => setSelectedItem(item)}
            >
              <View style={{ marginHorizontal: 20 }}>
                <View
                  style={{
                    marginTop: 5,
                    marginBottom: 5,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <View style={{}}>
                    <Text
                      style={{
                        fontFamily: AppFonts.OverpassRegular,
                        fontSize: 12,
                        color: AppColors.dualbrown,
                      }}
                    >
                      Address
                    </Text>

                    <Text
                      style={{
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                        color: AppColors.brown,
                      }}
                    >
                      {item.Vishrantwadiune}
                    </Text>
                  </View>
                  <TouchableOpacity onPress={() => handleThreeDotPress(item)}>
                    <Image
                      source={AppImages.Threedots}
                      style={{ width: 15, height: 15, alignItems: "center" }}
                      resizeMode="contain"
                    />
                  </TouchableOpacity>
                </View>
              </View>
            </TouchableOpacity>
          )}
          keyExtractor={(item) => item.id.toString()} // Assuming each item has a unique id property
          extraData={selectedItem} // Update when the selectedItem changes
          // onPress={() => setSelectedItem(item)}
        />
      </View>
      <Modal
        animationType="slide"
        visible={DotModal}
        onRequestClose={() => {
          setDotModal(false);
        }}
        transparent={true}
      >
        <Pressable style={styles.feed} onPress={() => setDotModal(false)}>
          <View style={styles.viww}>
            <TouchableOpacity style={styles.hsh}>
              <Image source={AppImages.LineBar} style={styles.jns} />
            </TouchableOpacity>

            <TouchableOpacity
              style={{
                marginTop: 15,
                flexDirection: "row",
              }}
              onPress={() => setDotModal(false)}
            >
              <View style={styles.yooo}>
                <Text style={styles.ttxt}>Approve</Text>
              </View>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.fffsf}
              onPress={handleDeleteConfirmation}
            >
              <View style={styles.yooo}>
                <Text style={styles.modo}>Reject</Text>
              </View>
            </TouchableOpacity>
          </View>
        </Pressable>
      </Modal>

      {/* //-----------DeleteModal------// */}

      <Modal
        animationType="slide"
        transparent={true}
        visible={Modalvisible1}
        onRequestClose={() => {
          setModalvisible1(!Modalvisible1);
        }}
      >
        <Pressable
          onPress={() => setModalvisible1(false)}
          style={styles.presse}
        >
          <View style={styles.dsdd}>
            <View style={styles.sss}>
              <View style={styles.fd}>
                <View style={{}}>
                  <Text style={styles.hbh}>Delete Parking Station</Text>
                </View>
              </View>
              <TouchableOpacity
                onPress={() => {
                  setModalvisible1(false);
                }}
              >
                <Image
                  source={AppImages.cross}
                  style={styles.hhsj}
                  resizeMode="contain"
                />
              </TouchableOpacity>
            </View>

            <View style={styles.lins}></View>
            <View style={styles.fasfd}>
              <Text style={styles.sdsds}>
                Are you sure you want to delete this Parking Station ?
              </Text>
            </View>

            <View style={styles.mmm}>
              <View style={styles.hox}>
                {ModalDel.map((item, index) => (
                  <View
                    onPress={() => handleBoxPressbtn(item)}
                    style={styles.presss}
                  >
                    {selectedButton === index ? (
                      <TouchableOpacity
                        onPress={() => [
                          handleDelete(),
                          // handleBoxPressbtn(item),
                          setModalvisible1(false),
                        ]}
                      >
                        <View style={{}}>
                          <View
                            style={[
                              styles.LoginWithOtpVw,
                              {
                                backgroundColor:
                                  selectedButton === index
                                    ? AppColors.brown
                                    : AppColors.C4900C,
                              },
                            ]}
                          >
                            <Text
                              style={[
                                styles.RegisterTxt,
                                {
                                  color:
                                    selectedButton === index
                                      ? AppColors.white
                                      : AppColors.C4900CC,
                                },
                              ]}
                            >
                              {item.label}
                            </Text>
                          </View>
                        </View>
                      </TouchableOpacity>
                    ) : (
                      <TouchableOpacity
                        onPress={() => [
                          // handleBoxPressbtn(item),
                          setModalvisible1(false),
                        ]}
                      >
                        <View style={{}}>
                          <View style={{}}>
                            <View
                              style={[
                                styles.LoginWithOtpVw,
                                {
                                  backgroundColor:
                                    selectedButton === index
                                      ? AppColors.brown
                                      : AppColors.C4900C,
                                },
                              ]}
                            >
                              <Text
                                style={[
                                  styles.RegisterTxt,
                                  {
                                    color:
                                      selectedButton === index
                                        ? AppColors.white
                                        : AppColors.C4900CC,
                                  },
                                ]}
                              >
                                {item.label}
                              </Text>
                            </View>
                          </View>
                        </View>
                      </TouchableOpacity>
                    )}
                  </View>
                ))}
              </View>
            </View>
          </View>
        </Pressable>
      </Modal>
    </View>
  );
};

export default SugestedParkStation;

const styles = StyleSheet.create({
  ims: { width: 22, height: 22 },
  ha: { width: 22, height: 22 },

  feed: { backgroundColor: AppColors.ModalColor, flex: 1 },
  viww: {
    width: "100%",
    backgroundColor: "white",

    borderTopRightRadius: 16,
    borderTopLeftRadius: 16,
    position: "absolute",
    bottom: 0,
    padding: 20,
  },
  hsh: { justifyContent: "center", alignItems: "center" },
  jns: { width: "15%", height: 2 },
  yooo: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 10,
  },
  ttxt: {
    fontFamily: AppFonts.OverpassMedium,

    fontSize: 14,
    color: AppColors.dualbrown,
  },
  fffsf: {
    marginTop: 2,
    flexDirection: "row",
  },
  modo: {
    fontFamily: AppFonts.OverpassMedium,

    fontSize: 16,
    color: AppColors.brown1,
  },
  presse: {
    flex: 1,
    backgroundColor: AppColors.ModalColor,
    alignItems: "center",
    justifyContent: "center",
  },
  fasfd: { marginTop: 10, marginHorizontal: 20 },

  dsdd: {
    backgroundColor: "white",
    borderRadius: 20,
    marginHorizontal: 20,
    width: "80%",
    paddingTop: 15,
  },
  sss: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 20,
    alignItems: "center",
  },
  lins: {
    borderTopWidth: 1,
    marginHorizontal: 20,
    // right: 20,
    borderTopColor: AppColors.sandal,
    marginTop: 10,
  },
  fd: { flexDirection: "row", alignItems: "center" },
  hbh: {
    fontFamily: AppFonts.OverpassMedium,
    fontSize: 20,
    lineheight: 25.32,
    color: AppColors.brown1,
  },
  hhsj: { width: 12, height: 12, alignItems: "center" },

  sdsds: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    lineheight: 17.72,
    color: AppColors.brown1,
  },
  RegisterTxt: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  RegisterNxt: {
    // color: AppColors.white,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  LoginWithOtpVw: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    height: 35,
    width: "100%",
  },
  hox: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginVertical: 20,
  },
  presss: {
    width: "40%",
    marginHorizontal: 10,
  },
  mmm: {
    flexDirection: "row",
    alignSelf: "flex-end",

    marginHorizontal: 20,
  },
  toda: { marginTop: 20, flexDirection: "row" },
});
